import React, { useState, useEffect } from 'react'
import SearchPresenter from './SearchPresenter'
import { moviesApi, tvApi } from '../../api'

const SearchContainer = (props) => {
    const { match: { params: { term } } } = props
    const [state, setState] = useState({
        loading: false,
        error: null,
        movieResult: null,
        tvResult: null,
    })
    const [change, setChange] = useState(term)
    const [termResult, setTermResult] = useState(term)
    const { loading, error, movieResult, tvResult } = state

    const handleSubmit = (e) => {
        e.preventDefault()
        if (change !== '') {
            props.history.push(`/search/${change}/`)
            setChange('')
        }
        if (change === '') {
            props.history.push('/search/')
            setChange('')
        }
    }
    const updateTerm = (e) => {
        e.preventDefault()
        setChange(e.target.value)
    }

    useEffect(() => {
        const getData = async (term) => {
            setState({ loading: true })
            try {
                if (term) {
                    const { data: { results: movieResult } } = await moviesApi.search(term)
                    const { data: { results: tvResult } } = await tvApi.search(term)
                    setState(prev => ({ ...prev, movieResult, tvResult, searchResult: term, loading: false }))
                }
                setState(prev => ({ ...prev, loading: false }))
            } catch (error) {
                setState(prev => ({ ...prev, error: "Can't find results.", loading: false }))
            }
        }
        if (!term) {
            setChange('')
            setTermResult('')
            setState(prev => ({
                ...prev,
                loading: false,
                error: null,
                movieResult: null,
                tvResult: null,
            }))
        }
        if (term) {
            setChange(term)
            setTermResult(term)
            getData(term)
        }
    }, [term])


    return (
        <SearchPresenter onSubmit={handleSubmit} onChange={updateTerm} searchResult={termResult} loading={loading} error={error} searchTerm={change} movieResult={movieResult} tvResult={tvResult} />
    )
}

export default SearchContainer












